import React, { useContext, useMemo, useState } from "react"
import { t } from '../../i18n-utility'
import { sortByProp } from '../../helper/arrays'
import DfbHeadline from "../ui-kit/dfb_headline"
import DfbButton from "../ui-kit/dfb_button"
import Section from "../blocks/section"
import CTeaserExternal from "../elements/c_teaser_external"
import CFilterEnhanced from "../elements/c_filter_enhanced"
import PageContext from "../page-context"

const FILTER_TYPE_CATEGORY = 'category'
const FILTER_TYPE_FORMAT = 'mediatype'

const MExternalContent = (props) => {
  const uid = props.data.uid
  const headline = props.data.headline
  const teasers = props.data.link_tile
  const filterType = props.data.frontend_filter

  const { translations } = useContext(PageContext)

  const [filteredTeasers, setFilteredTeasers] = useState(teasers);
  const [isFilterActive, setIsFilterActive] = useState(false);
  const [visibleTeaserCount, setVisibleTeaserCount] = useState(3);

  const filterFormats = useMemo(() => sortByProp('title', teasers.reduce((result, item) => {
    const format = item.media_type
    if (!result.find(aFormat => format === aFormat.uid)) {
      const title = t(translations, `mediaTypes.${format}`, true) || format
      result.push({
        uid: format,
        title,
      })
    }
    return result
  }, [])), [teasers])

  const filterCategories = useMemo(() => sortByProp('title', teasers.reduce((outerResult, item) => {
    return (item.categories || []).reduce((result, category) => {
      if (category.title && !result.find(aCategory => category.uid === aCategory.uid)) {
        result.push(category)
      }
      return result
    }, outerResult)
  }, [])), [teasers])

  const handleFilter = ({ formats, categories }) => {
    let updatedFilteredTeasers = teasers
    if (formats.length) {
      updatedFilteredTeasers = updatedFilteredTeasers.reduce((result, item) => {
        const format = item.media_type
        if (formats.includes(format)) {
          result.push(item)
        }
        return result
      }, [])
    }
    if (categories.length) {
      updatedFilteredTeasers = updatedFilteredTeasers.reduce((result, item) => {
        if (item.categories?.find(category => categories.includes(category.uid + ""))) {
          result.push(item)
        }
        return result
      }, [])
    }
    return updatedFilteredTeasers;
  }

  return (
    <Section
      baseClass={`m-ExternalContent ${!isFilterActive ? "m-ExternalContent--accentuated" : ""}`}
      className={props.className}
      data={props.data}
    >
      <div className="m-ExternalContent-wrapper">
        <div className="m-ExternalContent-container">
          <div className="m-ExternalContent-content">
            {headline && (
              <div className="c-Headline m-ExternalContent-headline">
                <DfbHeadline
                  headline={headline}
                  headline_level="h3"
                  add_class="c-Headline-strokeLine"
                />
              </div>
            )}

            {filterType !== "none" && (
              <CFilterEnhanced
                uid={uid}
                collection={teasers}
                filterFunction={handleFilter}
                filterFormats={filterType?.includes(FILTER_TYPE_FORMAT) ? filterFormats : []}
                filterCategories={filterType?.includes(FILTER_TYPE_CATEGORY) ? filterCategories : []}
                setFilteredCollection={setFilteredTeasers}
                setIsFilterActive={setIsFilterActive}
              />
            )}

            <div className="m-ExternalContent-teasers">
              {filteredTeasers.slice(0, visibleTeaserCount).map((teaser, index) => (
                <CTeaserExternal data={teaser} add_class="m-ExternalContent-teaser" key={index} />
              ))}
            </div>

            {visibleTeaserCount < filteredTeasers.length && (
              <div className="m-ExternalContent-load-more">
                <DfbButton
                  onClick={() => setVisibleTeaserCount(visibleTeaserCount + 6)}
                  text="Mehr laden"
                  tagName="button"
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </Section>
  )
}

export default MExternalContent
